<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';

  interface Props {
    name?: string;
    label?: string;
    checked?: boolean;
    tabIndex?: number;
    disabled?: boolean;
    indeterminateCheck?: boolean;
    children?: import('svelte').Snippet;
    onclick?: (e: MouseEvent) => void;
    onchange?: (e: Event) => void;
  }

  let {
    name = 'checkbox',
    label = '',
    checked = $bindable(false),
    tabIndex = 1,
    disabled = false,
    indeterminateCheck = false,
    children,
    onclick,
    onchange
  }: Props = $props();
</script>

<div
  class="comp-checkbox"
  class:disabled
  onclick={(e) => { e.stopPropagation(); onclick?.(e); }}
>
  <label for={name}>
    <input
      id={name}
      {tabIndex}
      bind:checked
      type="checkbox"
      hidden
      {disabled}
      onclick={(e) => { e.stopPropagation(); onclick?.(e); }}
      onchange={(e) => onchange?.(e)}
    />
    <div data-cy={name} class="fake-input">
      <div class="icon">
        {#if indeterminateCheck}
          <div class="indeterminate-check">{''}</div>
        {:else}
          <Icon value="icon-check white" size="14px" fontSize="14px" />
        {/if}
      </div>
    </div>
    {#if label}
      <div data-cy={`${name}-label`} class="text">{label}</div>
    {/if}
    {@render children?.()}
  </label>
</div>

<style>
  .comp-checkbox,
  .comp-checkbox label {
    display: flex;
    align-items: center;
  }
  .comp-checkbox label {
    cursor: pointer;
  }

  .fake-input {
    width: 16px;
    height: 16px;
    border: 1px solid #c6c9ce;
    box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.02);
    border-radius: 3px;
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
  }
  .fake-input .icon {
    display: none;
    align-items: center;
    justify-content: center;
  }
  .comp-checkbox input:checked ~ .fake-input {
    border-color: var(--blue);
    background-color: var(--blue);
  }
  .comp-checkbox input:checked ~ .fake-input .icon {
    display: flex;
  }
  .text {
    font-size: 14px;
    line-height: 22px;
    color: var(--grey-dark);
    font-weight: normal;
  }
  .comp-checkbox.disabled label {
    cursor: not-allowed;
  }
  .comp-checkbox.disabled .text {
    color: var(--grey-medium);
    font-weight: 400;
  }
  .comp-checkbox.disabled input:checked:disabled ~ .fake-input {
    border-color: var(--grey-medium);
    background-color: var(--grey-medium);
  }
  .comp-checkbox.disabled input:not(:checked):disabled ~ .fake-input {
    background: #e8eaef !important;
    border: 1px solid #c6c9ce !important;
    box-shadow: 1px 2px 2px rgb(0 0 0 / 2%) !important;
    border-radius: 3px !important;
  }
  .comp-checkbox input:checked ~ .fake-input .icon .indeterminate-check {
    background: #ffffff;
    padding: 1px 4px;
  }
</style>
